import { StyledSvg } from "baseui/icon";
import React from "react";

export const BigCommerceIcon = (props: React.ComponentProps<typeof StyledSvg>) => (
  <StyledSvg viewBox="0 0 20 20" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z"
      fill="#F8F8F8"
    />
    <path
      d="M10.186 10.7343H11.825C12.291 10.7343 12.5863 10.4776 12.5863 10.0656C12.5863 9.67697 12.291 9.39697 11.825 9.39697H10.186C10.1316 9.39697 10.085 9.44364 10.085 9.49031V10.6413C10.0926 10.6953 10.1316 10.7343 10.186 10.7343Z"
      fill="#393743"
    />
    <path
      d="M10.186 13.3861H11.8793C12.3996 13.3861 12.7106 13.1217 12.7106 12.6551C12.7106 12.2507 12.4153 11.9241 11.8793 11.9241H10.186C10.1316 11.9241 10.085 11.9707 10.085 12.0174V13.2851C10.0926 13.3471 10.1316 13.3861 10.186 13.3861Z"
      fill="#393743"
    />
    <path
      d="M16.1828 3.36205L11.3355 8.19905H12.1278C13.3628 8.19905 14.0931 8.97672 14.0931 9.82438C14.0931 10.4931 13.6425 10.9831 13.1611 11.2007C13.0835 11.2317 13.0835 11.3407 13.1688 11.3717C13.7281 11.5894 14.1241 12.1727 14.1241 12.857C14.1241 13.8214 13.4795 14.5911 12.2288 14.5911H8.79545C8.74112 14.5911 8.69445 14.5444 8.69445 14.4977V10.8354L3.37312 16.1391C3.30345 16.2091 3.34979 16.3334 3.45079 16.3334H16.2448C16.2915 16.3334 16.3301 16.2944 16.3301 16.2477V3.43205C16.3535 3.34672 16.2448 3.30005 16.1828 3.36205Z"
      fill="#393743"
    />
  </StyledSvg>
);
